
import { defineComponent, PropType } from 'vue'

// @components
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

const LIMITS = [
    {
        id: 1,
        value: 10,
    },
    {
        id: 2,
        value: 15,
    },
    {
        id: 3,
        value: 20,
    },
    {
        id: 4,
        value: 50,
    },
]

export default defineComponent({
    name: 'new-limit',
    props: {
        value: {
            type: [Number, null] as PropType<number | null>,
            default: null,
        },
        totalItems: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        TheSelect,
        Loader,
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const onChange = (new_value: number | null) => {
            if (props.disabled) return
            emit('update:value', new_value)
            emit('change', new_value)
        }

        return {
            LIMITS,
            onChange,
        }
    },
})
